import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { FiBell, FiSearch, FiMenu } from 'react-icons/fi';

export default function Header({ onMenuClick }) {
  const { user } = useAuth();
  const initials = user?.name ? user.name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2) : 'U';

  return (
    <header className="sticky top-0 z-30 flex items-center justify-between px-4 md:px-6 h-16 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b border-border">
      <div className="flex items-center gap-4">
        <button 
          className="md:hidden p-2 -ml-2 text-muted-foreground hover:text-foreground transition-colors"
          onClick={onMenuClick}
        >
          <FiMenu size={20} />
        </button>
        
        <div className="relative hidden md:flex items-center">
          <FiSearch className="absolute left-2.5 text-muted-foreground" size={16} />
          <input 
            type="text" 
            placeholder="Search..." 
            className="w-64 pl-9 pr-4 py-1.5 bg-muted/50 border border-transparent rounded-md text-sm text-foreground focus:outline-none focus:border-border focus:ring-1 focus:ring-ring transition-all placeholder:text-muted-foreground"
          />
        </div>
      </div>

      <div className="flex items-center gap-4 md:gap-5">
        <button className="relative text-muted-foreground hover:text-foreground transition-colors">
          <FiBell size={18} />
          <span className="absolute -top-1 -right-1 w-2 h-2 bg-destructive rounded-full border-2 border-background"></span>
        </button>

        <div className="flex items-center gap-3">
          <div className="hidden md:flex flex-col items-end">
            <span className="text-sm font-medium text-foreground leading-none">{user?.name || user?.email}</span>
            <span className="text-xs text-muted-foreground mt-1 capitalize">{user?.role?.replace('_', ' ')}</span>
          </div>
          <div className="w-8 h-8 rounded-full bg-secondary border border-border flex items-center justify-center text-secondary-foreground font-medium text-xs">
            {initials}
          </div>
        </div>
      </div>
    </header>
  );
}
